import { render, staticRenderFns } from "./LoginAccountOperate.vue?vue&type=template&id=06540178&scoped=true&"
import script from "./LoginAccountOperate.vue?vue&type=script&lang=js&"
export * from "./LoginAccountOperate.vue?vue&type=script&lang=js&"
import style0 from "./LoginAccountOperate.vue?vue&type=style&index=0&id=06540178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06540178",
  null
  
)

export default component.exports